/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetOrdersOrderIdCancelReasonsQueryResponse, GetOrdersOrderIdCancelReasonsPathParams, GetOrdersOrderIdCancelReasons400 } from "../entities/GetOrdersOrderIdCancelReasons";

function getGetOrdersOrderIdCancelReasonsUrl(order_id: GetOrdersOrderIdCancelReasonsPathParams["order_id"]) {
  const res = { method: 'GET', url: `/orders/${order_id}/cancel-reasons` as const }  
  return res
}

/**
 * @description Получение причин отмены заказа
 * @summary Получение причин отмены заказа
 * {@link /orders/:order_id/cancel-reasons}
 */
export async function getOrdersOrderIdCancelReasons(order_id: GetOrdersOrderIdCancelReasonsPathParams["order_id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetOrdersOrderIdCancelReasonsQueryResponse, ResponseErrorConfig<GetOrdersOrderIdCancelReasons400>, unknown>({ method : "GET", url : getGetOrdersOrderIdCancelReasonsUrl(order_id).url.toString(), ... requestConfig })  
  return res.data
}